
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class EscalationReason extends Vue {
  @Prop() private reason!: string;

  @Prop() private profilesMap!: ProfileMapInterface;

  private loading: boolean = false;

  private collapsed: boolean = false;
}
